
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgEventInvitationUpdate extends Vue {
    @Prop({type: Object, default: null}) private guest!: any;
    @Prop({type: Boolean, default: false}) private dialog!: any;

    @Action('admin/events/updateGuest') private updateGuest!: any;
    @Getter('common/rules/all') private rules!: any;

    private loading: boolean = false;
    private states: any = [
      {value: 0, text: 'Ausstehend'},
      {value: 70, text: 'Angenommen'},
      {value: 99, text: 'Abgelehnt'},
    ];

    private async save() {
      this.loading = true;
      const res = await this.updateGuest({id: this.guest.eventId, guest: this.guest});
      if (res) {
        this.$emit('updated');
        this.closeDialog();
      }
      this.loading = false;
    }

    private closeDialog() {
      this.$emit('close');
    }
  }
